import { Loading } from "icons";

const STATUS_TAG_COLORS = {
  succeeded: "#EBF4EC",
  analysed: "#EBF4EC",
  running: "#E8F4FD",
  incomplete: "#FDF0E3",
  cancelled: "#FDF0E3",
  failed: "#FAEAEA",
  pending: "#E8F4FD",
};

const STATUS_TAG_LABELS = {
  succeeded: "Ingested",
};

const STATUS_TAG_ICONS = {
  running: Loading,
};

export { STATUS_TAG_COLORS, STATUS_TAG_LABELS, STATUS_TAG_ICONS };
